import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import type { CategoryType, WidgetDataSource } from '../../types';
import { GigaBarWidget as GigaBarWidgetCloudscape } from './GigaBarWidget.cloudscape';
import { GigaBarWidgetHighcharts } from './GigaBarWidget.highcharts';
import type { GigaBarWidgetProps } from './GigaBarWidgetProps';

export const GigaBarWidget = <
  TDataSource extends WidgetDataSource,
  TCategory extends CategoryType,
  TSubCategory extends CategoryType,
>(
  props: GigaBarWidgetProps<TDataSource, TCategory, TSubCategory>
) => {
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  if (highchartsEnabled) {
    return <GigaBarWidgetHighcharts {...props} />;
  }

  return <GigaBarWidgetCloudscape {...props} />;
};
